import { render, staticRenderFns } from "./catelog.vue?vue&type=template&id=4c133e57&scoped=true&"
import script from "./catelog.vue?vue&type=script&lang=js&"
export * from "./catelog.vue?vue&type=script&lang=js&"
import style0 from "./catelog.vue?vue&type=style&index=0&id=4c133e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c133e57",
  null
  
)

export default component.exports